import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const LABEL = { ok: "OK", missing: "Missing", wrong_type: "Wrong type" };

export const PcoFieldCheck = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try { setD((await api.get("/integrations/pco/fields")).data); }
    catch (err) { toast.error(err.response?.data?.detail || "Could not read Planning Center fields"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-6" data-testid="pco-field-check">
      <button onClick={check} disabled={busy} className="chip-btn" data-testid="pco-field-check-btn">{busy ? "Checking..." : "Check Dream Teams fields"}</button>
      {d && !d.tab_found && <p className="text-sm text-red-700 mt-3">No "Dream Teams" tab was found in Planning Center People. Create a tab named "Dream Teams" with the fields listed in the setup guide.</p>}
      {d?.tab_found && (
        <ul className="mt-3 grid sm:grid-cols-2 gap-x-6 text-sm">
          {Object.entries(d.fields).map(([k, f]) => (
            <li key={k} className="flex justify-between py-1.5 border-b border-[var(--line)]" data-testid={`pco-field-${k}`}>
              <span className="text-navy">{f.name}</span>
              <span className={f.status === "ok" ? "text-teal" : "text-red-700"}>{LABEL[f.status]}{f.status !== "ok" ? ` (needs ${f.expected})` : ""}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
